var merge = require('lodash/merge')

const mutations = {
  SET_SEL_ORDER (state, order) {
    state.order = order
  },
  UPDATE_SEL_ORDER(state, order) {
    const mergedData = merge(state.order,order)
    state.order = mergedData
  }
 
}
export default mutations
